import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, Input } from '@angular/core'
import { AuthorizeService } from '../../service/authorize.service'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import {
  BsModalService,
  BsModalRef
} from '../../../../node_modules/ngx-bootstrap'
import { Subscription } from '../../../../node_modules/rxjs'
import { CaseTableComponent } from '../case-table/case-table.component'
import { CrmEditCaseComponent } from '../crm-edit-case/crm-edit-case.component'
import { ToastrService } from '../../../../node_modules/ngx-toastr'
import { CrmCaseComponent } from '../crm-case/crm-case.component';

@Component({
  selector: 'app-crm-screen-input',
  templateUrl: './crm-screen-input.component.html',
  styleUrls: ['./crm-screen-input.component.scss']
})
export class CrmScreenInputComponent implements OnInit {
  @ViewChild(CaseTableComponent) caseTableComponent: CaseTableComponent
  @ViewChild(CrmEditCaseComponent) crmEditCaseComponent: CrmEditCaseComponent
  @ViewChild(CrmCaseComponent) crmCaseComponent: CrmCaseComponent
  @ViewChild('information') information: TemplateRef<any>
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  @Output() displayCreate = new EventEmitter()
  @Output() displayEdit = new EventEmitter()
  modalRef: BsModalRef
  subscription: Subscription
  subscriptionCase: Subscription
  createFormData
  hiddenCreatePage = true
  clickedId
  isAE
  message = ''

  displayComponent = false
  displayInputPage = true
  displayEditPage = false
  displayCreatePage
  dataInput
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }

  constructor(
    private authorization: AuthorizeService,
    private cpmService: CpmService,
    private store: StoreService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(
        response => {
          if (!response) {
            return
          }
          const securitySymbol = response['securitySymbol']
          this.displayComponent = true
          if (securitySymbol === null) {
            this.displayComponent = false
          }
        },
        error => {
          this.displayComponent = false
        }
      )
  }

  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('CRM_CASE_EDIT')
  }

  async createCaseHandler(event) {
    const isAE = await this.cpmService
      .getIsAE(event.securitySymbol)
      .then(ae => Boolean(ae))
      .catch(() => false)
    if (!isAE) {
      this.alert({
        status: 'ERROR',
        message: 'You cannot create case for this security symbol.'
      })
      return
    }
    this.displayInputPage = false
    this.displayCreatePage = true
    this.displayCreate.emit(this.displayCreatePage)
    this.displayEditPage = false
    this.createFormData = event
    this.scrollToCaseView()
  }

  async editCaseHandler(event) {
    this.displayInputPage = false
    this.displayCreatePage = false
    this.displayEditPage = true
    this.displayEdit.emit(this.displayEditPage)
    this.clickedId = event.id
    this.scrollToCaseEdit()
  }

  onFinished(event) {
    this.displayInputPage = true
    this.displayCreatePage = false
    this.displayEditPage = false
    this.displayEdit.emit(this.displayEditPage)
    this.displayCreate.emit(this.displayCreatePage)
    this.alert(event)
    this.caseTableComponent.ngOnInit()
  }

  reInitialTable() {
    this.caseTableComponent.onChangeData()
  }

  alert(event) {
    // console.log(event, '-- event')
    switch (event.status) {
      case 'OK':
        this.toastr.success('Successful')
        break
      case 'WARNNING':
        // this.toastr.info(event.message)
        break
      default: {
        this.message = event.status
        this.openModal(this.templateSaved)
      }
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }

  closeModal() {
    this.modalRef.hide()
  }
  scrollToCaseView() {
    const elmnt = document.getElementById('caseView')
    elmnt.scrollIntoView()
  }
  scrollToCaseEdit() {
    const elmnt = document.getElementById('caseEdit')
    elmnt.scrollIntoView()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/crm-screen-input/crm-screen-input.component.ts